/**
 * The OS share sheet, where the browser has one (BP-13 §6).
 *
 * `undefined` rather than a no-op when there is none: a screen can then hide
 * its share button instead of drawing one that silently does nothing, which
 * is the call `features/licensing` makes for the clipboard and
 * `features/photos` makes here.
 *
 * **The Web Share API, not a Capacitor plugin.** `@capacitor/share` is not a
 * dependency of this build and adding one means a native rebuild and a new
 * permission review for both stores; BP-11 §12's boundary would also put it
 * in this directory, so this module is where it would land when a BP decides
 * that is worth doing. Until then the detect below is the whole contract: iOS
 * WKWebView and desktop Safari/Chrome implement `navigator.share`, Android's
 * System WebView does not, and the client there reads "this device has no
 * share sheet" — which is true.
 */
export type ShareFn = (url: string, title: string) => Promise<void>;

/** A share function, or `undefined` where the browser has no share sheet. */
export function webShare(nav: Navigator = navigator): ShareFn | undefined {
  if (typeof nav.share !== 'function') {
    return undefined;
  }
  return async (url: string, title: string) => {
    await nav.share({ url, title });
  };
}
